import CategoryEventsSection from './categoryEventsSection/categoryEventsSection.component';

export {CategoryEventsSection};